export const theme = {
	colors:{
		primary: '#FF6768',
		primaryLight: '#FF8B8B',
		primaryDark: '#E34040',
		white: '#FFFFFF',
		black: '#333333',
		grey: '#777777',
		lightGrey: '#F6F6F6'
	},
	textColor:{
		primary: '#FF6768',
		black: '#333333',
		grey: '#777777',
		lightGrey: '#F6F6F6',
		white: '#FFFFFF',
	},
	fontFamily:{
		Raleway: "'Raleway', sans-serif;",
		Ranga: "'Ranga', cursive;",
		Roboto: "'Roboto', sans-serif;"
	},
	/*fontSize:*/
	maxWidth: '79.25rem', /* 1268/16 */
	breakpoint: {
		tablet: '@media screen and (min-width: 48em)', /* 768/16 */
		desktop: '@media screen and (min-width: 62em)' /* 992/16 */
	},

	padding:{
		s: '0.5em', /* 8/16 */
		m: '0.9375em', /* 15/16 */
		l: '1.5625em' /* 25/16 */
	},

	margin:{
		s: '0.5em', /* 8/16 */
		m: '0.9375em', /* 15/16 */
		l: '1.5625em' /* 25/16 */
	}

}